import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/default/button';

import { ResultState } from '../result-state';
import NoResultsDark from './assets/no-results-dark.svg';
import NoResultsLight from './assets/no-results-light.svg';
import { messages } from './messages';

type ResultsNoneProps = {
	filtersEnabled: boolean;
	clearFilters: () => void | Promise<void>;
};

export const ResultsNone = ({
	filtersEnabled,
	clearFilters,
}: ResultsNoneProps): React.JSX.Element => {
	return (
		<ResultState
			imageSrcLight={NoResultsLight}
			imageSrcDark={NoResultsDark}
			primaryText={<FormattedMessage {...messages.noResultsPrimary} />}
			secondaryText={
				filtersEnabled ? (
					<FormattedMessage {...messages.noResultsSecondaryFilters} />
				) : (
					<FormattedMessage {...messages.noResultsSecondary} />
				)
			}
			callToAction={
				filtersEnabled ? (
					<Button appearance="primary" onClick={clearFilters}>
						<FormattedMessage {...messages.noResultsClearFilters} />
					</Button>
				) : undefined
			}
			testId="search-page-results-none"
		/>
	);
};
